"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _trial = require("@/api/trial.js");
var _viewMixin = _interopRequireDefault(require("@/views/trial/components/mixins/viewMixin.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_viewMixin.default],
  data: function data() {
    return {
      req: {
        reqPage: _trial.markCommonlyPage,
        reqInsert: _trial.markCommonlyInsert,
        reqUpdate: _trial.markCommonlyUpdate,
        reqDelete: _trial.markCommonlyDelete
      },
      title: "会议通道",
      tableHeaderColor: this.$tableHeaderColor,
      titlevalue: "",
      fileList: [],
      form: {
        title: "",
        commonlyContent: ""
      },
      formRules: {
        title: [{
          required: true,
          message: "请输入标题名"
        }],
        commonlyContent: [{
          required: true,
          message: "请输入内容"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    getData: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var page,
          data,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
              data = {}; // if (this.statevalue != "") {
              //   data["state"] = this.statevalue;
              // }
              if (this.titlevalue != "") {
                data["title"] = this.titlevalue;
              }
              _context.next = 5;
              return this.getList(page, data);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    clearAllConditon: function clearAllConditon() {
      this.statevalue = "";
      this.titlevalue = "";
      this.getData(1);
    }
  },
  mounted: function mounted() {
    this.getData(1);
  }
};
exports.default = _default;